const map = {
  // 智能调拨配置
  transferStoreList: () =>
    import('@/views/intelligentAllocation/TransferStoreList'), // 调拨仓库配置
  transferWarningList: () =>
    import('@/views/intelligentAllocation/TransferWarningList'), // 调拨预警配置
  transferBillList: () =>
    import('@/views/intelligentAllocation/TransferBillList'), // 预调拨单
  warningBillList: () =>
    import('@/views/intelligentAllocation/WarningBillList'), // 预警单
  warehouseConfigList: () =>
    import('@/views/intelligentAllocation/WarehouseConfigList'), // 仓库基础配置
  brandAllocationStatistics: () =>
    import('@/views/intelligentAllocation/BrandAllocationStatistics') // 品牌调拨统计配置
}

export default map
